import {useEffect, useRef, useState} from 'react'
import NavBreadcrumb from '../../../components/NavBreadcrumb'
import DigitalAssessLayout from '../components/DigitalAssessLayout'
import DrawerPage from '../components/DrawerPage'
import MyDivTable from '../components/MyDivTable'
import styles from './indexInput.module.less'

const crumb = [{name: '数字评价'}, {name: '指标录入'}]

export default function DigitalAssessIndexInput() {
  const myRef = useRef<{loadData: () => void}>()
  const drawerRef = useRef<{setShowDrawer: (isShow: boolean) => void}>()
  const [curEdit, setCurEdit] = useState<any>({})

  useEffect(() => curEdit.id && drawerRef.current?.setShowDrawer(true), [curEdit])

  return (
    <DigitalAssessLayout>
      <NavBreadcrumb itemList={crumb} />
      <div id={styles.indexInput}>
        <MyDivTable onRef={myRef} onOperate={setCurEdit} screenType={1} />
        <DrawerPage key={Math.random()} onRef={drawerRef} curEdit={curEdit} onClose={myRef.current?.loadData} />
      </div>
    </DigitalAssessLayout>
  )
}
